module.exports = __webpack_public_path__ + "static/img/platform-bg-2.235b661.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/platform-bg-2.png
// module id = /ik2
// module chunks = 0